module.exports = __webpack_public_path__ + "img/ebike.f3b2bc19.jpg";